(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-component.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-component.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const _svs$ui = svs.ui,
  Bank = _svs$ui.ReactBank,
  Icon = _svs$ui.ReactIcon;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$accountservicesR = svs.accountservicesReact.deposit.store.deposit.actions,
  selectedDepositMethodChange = _svs$accountservicesR.selectedDepositMethodChange,
  instantPayChange = _svs$accountservicesR.instantPayChange;
const DepositLimits = svs.accountservicesReact.deposit.depositLimits.DepositLimits;
const LoaderPanel = svs.accountservicesReact.deposit.LoaderPanel;
const BlockInfo = svs.accountservicesReact.deposit.depositBlock.BlockInfo;
const InlineMessage = svs.components.tb_ui_react.inlineMessage.InlineMessage;
const SwedbankExpress = svs.accountservicesReact.deposit.swedbankExpress.SwedbankExpress;
const BankCard = svs.accountservicesReact.deposit.bankCard.BankCard;
const ApplePay = svs.accountservicesReact.deposit.applePay.ApplePay;
const Swish = svs.accountservicesReact.deposit.swish.Swish;
const WithdrawalInfo = svs.accountservicesReact.deposit.depositShared.WithdrawalInfo;
const DepositCcWarning = svs.accountservicesReact.deposit.depositShared.DepositCcWarning;
const amountLimits = svs.accountservicesReact.deposit.constants.amountLimits;
const DepositComponent = _ref => {
  var _svs$accountservicesR2, _blockInfo$depositRes;
  let _ref$instantPay = _ref.instantPay,
    instantPay = _ref$instantPay === void 0 ? {} : _ref$instantPay,
    hasNoProfileLinkSwish = _ref.hasNoProfileLinkSwish,
    isHideDepositLimits = _ref.isHideDepositLimits,
    _ref$isPlayerRegistra = _ref.isPlayerRegistration,
    isPlayerRegistration = _ref$isPlayerRegistra === void 0 ? false : _ref$isPlayerRegistra,
    swedbankPayProps = _ref.swedbankPayProps;
  const dispatch = ReactRedux.useDispatch();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    blockInfo = _useState2[0],
    setBlockInfo = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isCheckBlock = _useState4[0],
    setIsCheckBlock = _useState4[1];
  const setLastDepositMethodAsync = svs.accountservicesReact.deposit.helpers.sharedHelpers.setLastDepositMethodAsync;
  const isShowApplePay = svs.core.detect.browser.safari() && (svs.core.detect.os.iOS() || svs.core.detect.os.osX());
  const getBlockingInfo = svs.accountservicesReact.deposit.helpers.blockingInfoHelper.getBlockingInfo;
  const isTransactionsLimitsSet = ((_svs$accountservicesR2 = svs.accountservicesReact.deposit) === null || _svs$accountservicesR2 === void 0 || (_svs$accountservicesR2 = _svs$accountservicesR2.data) === null || _svs$accountservicesR2 === void 0 || (_svs$accountservicesR2 = _svs$accountservicesR2.transactionLimits) === null || _svs$accountservicesR2 === void 0 ? void 0 : _svs$accountservicesR2.limitsIsSet) || false;
  const reduxInstantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const selectedDepositMethod = ReactRedux.useSelector(state => state.deposit.selectedDepositMethod);
  const bankCardComponentRef = useRef(null);
  const applePayComponentRef = useRef(null);
  const maxLimitRemainingStr = ReactRedux.useSelector(state => {
    var _state$deposit$maxLim;
    return (_state$deposit$maxLim = state.deposit.maxLimits) === null || _state$deposit$maxLim === void 0 ? void 0 : _state$deposit$maxLim.spendLimitRemaining;
  }) || '1000000,00';
  const maxLimitRemaining = parseInt(maxLimitRemainingStr, 10);
  const showCreditcardBan = svs.core.detect.feature('ft-cc-ban-text-bankcard-applepay');
  if (!reduxInstantPay) {
    dispatch(instantPayChange(instantPay));
  } else {
    instantPay = reduxInstantPay;
  }

  if (!selectedDepositMethod) {
    dispatch(selectedDepositMethodChange(paymentTypes.SWISH));
  }
  const handleSelect = async (paymentName, instantPay) => {
    await setLastDepositMethodAsync(paymentName);
    if (instantPay) {
      dispatch(instantPayChange(instantPay));
    }
    dispatch(selectedDepositMethodChange(paymentName));
  };
  const handleSelectAndTrack = paymentName => {
    handleSelect(paymentName);
    const previousPaymentMethod = selectedDepositMethod;
    const trackSwitchMainPayment = function () {
      let paymentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown';
      svs.components.analytics.trackEvent({
        category: 'Deposits',
        action: 'Deposit Cancel Dropdown',
        opt_label: paymentType
      });
    };
    if (previousPaymentMethod === paymentTypes.SWISH && paymentName !== paymentTypes.SWISH) {
      trackSwitchMainPayment('Swish');
    } else if (previousPaymentMethod === paymentTypes.APPLEPAY && paymentName !== paymentTypes.APPLEPAY) {
      trackSwitchMainPayment('CC ApplePay');
      if (applePayComponentRef.current) {
        applePayComponentRef.current.cleanUpSwedbankPayOnDropdownChange();
      }
    } else if (previousPaymentMethod === paymentTypes.BANKCARD && paymentName !== paymentTypes.BANKCARD) {
      trackSwitchMainPayment('CC');
      if (bankCardComponentRef.current) {
        bankCardComponentRef.current.cleanUpSwedbankPayOnDropdownChange();
      }
    } else if (previousPaymentMethod === paymentTypes.SWEDBANKEXPRESS && paymentName !== paymentTypes.SWEDBANKEXPRESS) {
      trackSwitchMainPayment('SwedbankExpress');
    }
  };
  useEffect(() => {
    const checkIfBlocked = async () => {
      const blockingInfo = await getBlockingInfo(maxLimitRemaining);
      setBlockInfo(blockingInfo);
      if (!blockingInfo) {
        handleSelect(selectedDepositMethod);
      }
    };
    if (isCheckBlock || maxLimitRemaining < amountLimits.MIN) {
      checkIfBlocked();
      setIsCheckBlock(false);
    }

  }, [isCheckBlock, maxLimitRemaining]);
  const onBoardingUrl = "".concat(svs.core.urlMapping.get('transactionsHome'), "/komplettera-uppgifter");
  const depositLimitsUrl = "".concat(onBoardingUrl, "/insattningsgranser?setLimits=true&returnUrl=").concat(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('transactionsHome')));
  const isSetLimits = Boolean(svs.utils.url.queryString.setLimits);


  const trackButtonToDepositLimits = () => {
    svs.components.analytics.trackEvent({
      category: 'set_deposit_limit_page_insattning',
      action: 'click_set_deposit_limit'
    });
  };
  const handleNavigateToDepositLimits = () => {
    trackButtonToDepositLimits();
    svs.utils.url.navigate(depositLimitsUrl);
  };
  const headingText = () => {
    var _instantPay;
    if (instantPay.product === 'spela-tillsammans') {
      return 'Sätt in och för över till laget';
    }
    if ((_instantPay = instantPay) !== null && _instantPay !== void 0 && _instantPay.isDepositAndPay) {
      return 'Sätt in och betala spelet';
    }
    return 'Sätt in pengar på spelkontot';
  };
  return React.createElement("div", null, (isTransactionsLimitsSet || isHideDepositLimits) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "transaction-deposit"
  }, blockInfo === null && React.createElement(LoaderPanel, null), blockInfo && React.createElement(BlockInfo, {
    blockInfo: blockInfo,
    setIsCheckBlock: setIsCheckBlock
  }), blockInfo !== null && !blockInfo && React.createElement(React.Fragment, null, !isPlayerRegistration && !isSetLimits && React.createElement("h2", {
    className: "h3 margin-v-1 f-center"
  }, headingText()), showCreditcardBan && (selectedDepositMethod === paymentTypes.BANKCARD || selectedDepositMethod === paymentTypes.APPLEPAY) && React.createElement(DepositCcWarning, null), React.createElement(DropdownSelectItem, {
    branding: "transaction-deposit",
    className: "js-dropdown-deposit drop-down-deposit",
    defaultText: "Hur vill du s\xE4tta in?",
    onSelect: handleSelectAndTrack,
    selectLabel: isPlayerRegistration ? '' : 'Välj insättningsmetod',
    v2: true
  }, React.createElement(DropdownItem, {
    name: paymentTypes.SWISH,
    selected: selectedDepositMethod === paymentTypes.SWISH
  }, React.createElement(Bank, {
    className: "bank-container",
    height: 24,
    name: "swish"
  })), isShowApplePay ? React.createElement(DropdownItem, {
    name: paymentTypes.APPLEPAY,
    selected: selectedDepositMethod === paymentTypes.APPLEPAY
  }, React.createElement(Bank, {
    className: "bank-container",
    height: 24,
    name: "apple-pay"
  }), React.createElement(DropdownLabel, null, "Apple Pay")) :
  React.createElement(React.Fragment, null), React.createElement(DropdownItem, {
    name: paymentTypes.BANKCARD,
    selected: selectedDepositMethod === paymentTypes.BANKCARD
  }, React.createElement(Icon, {
    color: "fc-navy",
    icon: "creditcard"
  }), React.createElement(DropdownLabel, null, "Bankkort")), React.createElement(DropdownItem, {
    name: paymentTypes.SWEDBANKEXPRESS,
    selected: selectedDepositMethod === paymentTypes.SWEDBANKEXPRESS
  }, React.createElement(Bank, {
    className: "bank-container",
    height: 24,
    name: "swedbank-sparbankerna"
  }), React.createElement(DropdownLabel, null, "Direkt fr\xE5n ditt bankkonto"))))), blockInfo !== null && !blockInfo && React.createElement("div", null, selectedDepositMethod === paymentTypes.BANKCARD && React.createElement(BankCard, {
    isPlayerRegistration: isPlayerRegistration,
    ref: bankCardComponentRef,
    swedbankPayProps: swedbankPayProps
  }), selectedDepositMethod === paymentTypes.APPLEPAY && React.createElement(ApplePay, {
    isPlayerRegistration: isPlayerRegistration,
    ref: applePayComponentRef,
    swedbankPayProps: swedbankPayProps
  }), selectedDepositMethod === paymentTypes.SWISH && React.createElement(Swish, {
    handleSelect: handleSelect,
    hasNoProfileLinkSwish: hasNoProfileLinkSwish,
    isPlayerRegistration: isPlayerRegistration,
    setIsCheckBlock: setIsCheckBlock
  }), selectedDepositMethod === paymentTypes.SWEDBANKEXPRESS && React.createElement(SwedbankExpress, {
    isPlayerRegistration: isPlayerRegistration
  }), !selectedDepositMethod && isPlayerRegistration && React.createElement(WithdrawalInfo, null)), !isHideDepositLimits && blockInfo !== null && (blockInfo === false || (blockInfo === null || blockInfo === void 0 || (_blockInfo$depositRes = blockInfo.depositRestrictions) === null || _blockInfo$depositRes === void 0 ? void 0 : _blockInfo$depositRes.showFirstDialog)) && React.createElement(DepositLimits, null)), !isHideDepositLimits && !isTransactionsLimitsSet && React.createElement("div", {
    className: "transaction-deposit margin-top-4"
  }, React.createElement(InlineMessage, {
    actions: [{
      handleClick: handleNavigateToDepositLimits,
      text: 'Sätt insättningsgränser'
    }],
    buttonOptions: {
      block: true,
      transparent: true
    },
    header: "Ins\xE4ttningsgr\xE4nser",
    icon: "deposit-limits"
  }, "Innan du s\xE4tter in pengar m\xE5ste du s\xE4tta dina ins\xE4ttningsgr\xE4nser. Ins\xE4ttningsgr\xE4nser \xE4r ett lagkrav och ger dig b\xE4ttre koll p\xE5 dina ins\xE4ttningar och ditt spelande.")));
};
svs.accountservicesReact.deposit.DepositComponent = DepositComponent;

 })(window);